module.exports = __webpack_public_path__ + "img/238.62510423.png";